// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <h3 className={styles.footerTitle}>MakeMeSongs</h3>
          <p className={styles.footerText}>
            Custom songs for your special moments, 
            professionally written and produced just for you.
          </p>
          <div className={styles.socialLinks}>
            <a href="https://www.facebook.com/sharer/sharer.php?u=makemesongs.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
        
        <div className={styles.footerSection}>
          <h3 className={styles.footerTitle}>Quick Links</h3>
          <ul className={styles.footerLinks}>
            <li><Link to="/" className={styles.footerLink}>Home</Link></li>
            <li><Link to="/packages" className={styles.footerLink}>Packages</Link></li>
            <li><Link to="/dashboard" className={styles.footerLink}>My Songs</Link></li>
            <li><Link to="/about" className={styles.footerLink}>About Us</Link></li>
            <li><Link to="/faq" className={styles.footerLink}>FAQ</Link></li>
          </ul>
        </div>
        
        <div className={styles.footerSection}>
          <h3 className={styles.footerTitle}>Contact Us</h3>
          <p className={styles.contactInfo}>
            <i className="fas fa-envelope"></i>
            <span><a href="mailto:support@mail.makemesongs.com">support@mail.makemesongs.com</a></span>
          </p>
          <p className={styles.contactInfo}>
            <i className="fas fa-phone"></i>
            <span><a href="tel:7548008154">(754) 800-8154</a></span>
          </p>
          <Link to="/contact" className={styles.contactButton}>
            Send a Message
          </Link>
        </div>
      </div>
      
      <div className={styles.footerBottom}>
        <div className={styles.footerCopyright}>
          © {currentYear} MakeMeSongs. All rights reserved.
        </div>
        <div className={styles.footerLegal}>
        <Link to="/terms-privacy#terms" className={styles.legalLink}>Terms of Service</Link>
        <Link to="/terms-privacy#privacy" className={styles.legalLink}>Privacy Policy</Link>
        <Link to="/terms-privacy#refund" className={styles.legalLink}>Refund Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;